export const AboutApi = {
  about: '/page/slug',
};
